import { gql } from "@grandvisionhq/graphql";
import OptInsFragment from "../../../../fragments/OptIns/operations/fragments/opt-ins-fragment.js";
const UPDATE_OPT_INS = gql`
  mutation updateOptIns($customerId: ID!, $optinUpdates: [OptInsInput!]!) {
    updateB2COptIns(customerId: $customerId, optinUpdates: $optinUpdates) {
      id
      optIns {
        ...OptInsFragment
      }
      __typename
    }
  }
  ${OptInsFragment}
`;
export {
  UPDATE_OPT_INS as default
};
//# sourceMappingURL=update-opt-ins.js.map
